import { useState } from "react";
import moment from "moment";
import CalendarWeb from "./CalendarWeb";

const REBATE_FIELDS = ["Slot", "Live", "Fishing", "Poker", "Total"];
const HISTORY_HEADERS = ["Game type", "Time", "Transaction amount", "Order reference number"];
const FORMAT = "YYYY-MM-DD HH:mm:ss";

const presetRange = (preset) => {
  if (preset === "yesterday") {
    const day = moment().subtract(1, "day");
    return { fromPeriod: day.startOf("day").format(FORMAT), toPeriod: day.endOf("day").format(FORMAT) };
  }
  return {
    fromPeriod: moment().subtract(preset === "7days" ? 6 : 0, "days").startOf("day").format(FORMAT),
    toPeriod: moment().endOf("day").format(FORMAT),
  };
};

function MyRebate() {
  const [betDate, setBetDate] = useState(() => moment().format("YYYY-MM-DD"));
  return (
    <div className="ref-rebate-mine">
      <div className="ref-rebate-form">
        <div className="ref-rebate-row">
          <label>Settlement Date</label>
          <input disabled type="text" value={betDate} readOnly />
        </div>
        {REBATE_FIELDS.map((name) => (
          <div className="ref-rebate-row" key={name}>
            <label>{name}</label>
            <input disabled type="text" value="0.00" readOnly />
          </div>
        ))}
      </div>
      <div className="ref-rebate-footer">
        <button type="button" className="ref-rebate-refresh" onClick={() => setBetDate(moment().format("YYYY-MM-DD"))}>
          Refresh
        </button>
        <button type="button" className="ref-rebate-claim" disabled>
          Receive
        </button>
      </div>
    </div>
  );
}

function RebateHistory() {
  const [preset, setPreset] = useState("today");
  const [range, setRange] = useState(() => presetRange("today"));
  const [showCalendar, setShowCalendar] = useState(false);
  const [decimals, setDecimals] = useState(false);

  const choose = (next) => {
    setPreset(next);
    setRange(presetRange(next));
  };

  return (
    <div className="ref-rebate-history">
      <div className="ref-rebate-search">
        {[
          ["today", "Today"],
          ["yesterday", "Yesterday"],
          ["7days", "7-Days"],
        ].map(([key, label]) => (
          <label className="ref-rebate-radio" key={key}>
            <input type="radio" name="rebate-history-date" checked={preset === key} onChange={() => choose(key)} />
            <span>{label}</span>
          </label>
        ))}
        <label className="ref-rebate-radio">
          <input type="radio" name="rebate-history-date" checked={preset === "custom"} onChange={() => setPreset("custom")} />
          <button
            type="button"
            className="ref-rebate-date"
            onClick={() => {
              setPreset("custom");
              setShowCalendar(true);
            }}
          >
            {`${moment(range.fromPeriod).format("MM/DD")}~${moment(range.toPeriod).format("MM/DD")}`}
          </button>
        </label>
        <button type="button" className="ref-rebate-search-btn">
          Search
        </button>
      </div>
      {showCalendar ? (
        <CalendarWeb
          fromPeriod={range.fromPeriod}
          toPeriod={range.toPeriod}
          setFilter={(update) => setRange((prev) => (typeof update === "function" ? update(prev) : update))}
          onCancel={() => setShowCalendar(false)}
        />
      ) : null}
      <div className="ref-rebate-table">
        <div className="ref-rebate-thead">
          {HISTORY_HEADERS.map((label) => (
            <div key={label}>{label}</div>
          ))}
        </div>
        <div className="ref-rebate-empty">No matched data found</div>
      </div>
      <div className="ref-rebate-page">
        <div className="ref-rebate-decimal">
          <span>Decimal point</span>
          <button
            type="button"
            className={decimals ? "on" : undefined}
            aria-pressed={decimals}
            aria-label="Decimal point"
            onClick={() => setDecimals((value) => !value)}
          />
        </div>
      </div>
    </div>
  );
}

export default function ManualRebate() {
  const [tab, setTab] = useState("mine");
  return (
    <div className="ref-rebate" id="mc_container">
      <div className="ref-rebate-tabs">
        <button type="button" className={tab === "mine" ? "active" : undefined} onClick={() => setTab("mine")}>
          My Rebates
        </button>
        <button type="button" className={tab === "history" ? "active" : undefined} onClick={() => setTab("history")}>
          Rebate History
        </button>
      </div>
      {tab === "mine" ? <MyRebate /> : <RebateHistory />}
    </div>
  );
}
